/*
 * @Descripttion:
 * @version: 购物地址接口
 * @Author: limin
 * @Date: 2021-03-23 17:18:02
 * @LastEditors: limin
 * @LastEditTime: 2021-04-12 14:12:22
 */
import request from '../request'
import {sys} from '@/utils'
const path = 'ddh.carlife.intelligent.delivery.address';
const addressTypePath = 'ddh.carlife.intelligent.address';

export default {
  /**
   * 获取家/公司地址
   */
  getHomeAndCompanyAddr(data={}) {
    data.method = `${addressTypePath}.byuser.get`;
    return request(data);
  },
  /**
   * 新增家/公司地址
   */
  addHomeAndCompanyAddr(data={}) {
    data.method = `${addressTypePath}.add`;
    return request(data);
  },
  /**
   * 获取地址列表
   */
  get(data={}) {
    data.method = `${path}.byuser.get`
    return new Promise(resolve=>{
        request(data).then(adds=>{
          let format = []
          if(adds && adds.length){
            format = adds.map(o=>sys.address_format_server_to_sys(o))
          }
          resolve(format)
        })
    })
  },
  /**
   * 设置默认地址
   */
  setDefault(id) {
    let data = {
      id,
      method: `${path}.default.edit`
    }
    return request(data);
  },
  /**
   * 获取默认地址
   */
   getDefault(data={}) {
    data.method = `${path}.default.get`
    return request(data);
  },
  /**
   * 新增地址
   * @param {} data 地址信息
   */
  add(data){
    data.method = `${path}.add`
    return request(data)
  },
  /**
   * 修改地址
   * @param {} data 地址信息
   */
  edit(data){
    data.method = `${path}.edit`
    return request(data)
  },
   /**
   * 删除地址
   * @param {} address
   */
  remove(id){
    let data = {
      id,
      method: `${path}.delete`
    }
    return request(data);
  }
}
